<script lang="ts" setup>
import { cva } from 'class-variance-authority';
import { computed } from 'vue';
import { cn } from '@/helpers/tailwind-helpers';
import { BaseFieldProps } from 'vee-validate';
import type { EnterKeyHint } from '@/constant/inputs';

export type InputState = 'default' | 'filled' | 'focused' | 'disabled' | 'hover';

export type BaseInputProps = {
  id: string;
  placeholder?: string;
  class?: string;
  destructive?: boolean;
  disabled?: boolean;
  state?: InputState;
  fieldProps?: BaseFieldProps;
  type:
    | 'text'
    | 'number'
    | 'tel'
    | 'password'
    | 'email'
    | 'checkbox'
    | 'textarea'
    | 'datetime-local';
  minLength?: number;
  maxLength?: number;
  max?: number;
  enterkeyhint?: EnterKeyHint;
};

const baseInput = cva(
  'flex space-x-2 items-center bg-grey-200 rounded-2xl py-2.5 px-3 bg-secondary justify-between border-brand-solid first-letter:uppercase',
  {
    variants: {
      destructive: {
        true: 'border border-error-solid',
        false: '',
      },
      state: {
        default: '',
        filled: '',
        focused: 'border-2',
        disabled: '',
        hover: '',
      },
      type: {
        text: 'h-13',
        number: 'h-13',
        tel: 'h-13',
        password: 'h-13',
        email: 'h-13',
        checkbox: 'h-13',
        textarea: 'h-auto min-h-24 items-start',
      },
    },
    compoundVariants: [],
    defaultVariants: {},
  },
);

const props = defineProps<BaseInputProps>();
const classes = computed(() => cn(baseInput(props), props.class));
</script>

<template>
  <div :class="classes">
    <slot name="left-slot" />
    <slot />
    <slot name="right-slot" />
  </div>
</template>
